export const sipTarget = (phone: string, domain: string) => {
  const user = String(phone || '').replace(/[^\d+]/g, '');
  const host = String(domain || '').replace(/^sip:/i, '');
  return `sip:${user}@${host}`;
};

export const remoteSipUser = (session?: { remote_identity?: { uri?: { user?: string } } } | null) => (
  String(session?.remote_identity?.uri?.user || '').trim()
);
